/* eslint-disable  */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// React Components
/* eslint-disable */
import React, { useEffect, useState, Suspense, lazy } from "react";
/* eslint-disable */
import "../layout-one/sass/app.scss";
import "../layout-two/sass-react/app.scss";
/* eslint-disable */
import ReactGA from "react-ga";
import { configure } from "mobx";
import DineInMain from "./DineInMain.jsx";
import DeliveryMain from "./DeliveryMain";
import EnabillLoadingPage from "../sharedComponent/enabillLoadingPage/enabillLoadingPage";
import { use } from "react";
import { useSelector } from "react-redux";
import { getCountryCode, getPhoneNumber, handelNumber } from "../global-functions/splitCountryCode.js";

// const EnabillLoadingPage = lazy(() => import(
//   '../sharedComponent/enabillLoadingPage/enabillLoadingPage'))

  
  
configure({
  isolateGlobalState: true,
});
const TRACKING_ID = "UA-243425614-1"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function Main({ t, i18n }) {
  const appState = useSelector((appState) => appState);
  const [appMode, setAppMode] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    //console.log("onpaymentauthorized3",JSON.stringify(event?.payment?.shippingContact?.phoneNumber));
     const numArr =  [ "+0505194242",
      "+0503377996",
      "+0561176955",
      "+0543733304",
      "+0502712662",
      "965+955534",
      "+0501551239",
      "+0566788876",
      "+0567551539",
      "+0504404166",
      "+0526482228",
      "+0554493449",
      "+0506781918",
      "+0549662040",
      "+0543449949",
      "+0508040090"];
    const formatedNumber = handelNumber(numArr[0]);
    numArr.forEach((element, ind) => {
      const formatedNumber = handelNumber(element);
      const countryCode = getCountryCode(formatedNumber);
      const phoneNumber = getPhoneNumber(formatedNumber,countryCode)
    });
    const countryCode = getCountryCode(formatedNumber);
    const phoneNumber = getPhoneNumber(formatedNumber,countryCode)
   }, [])
  useEffect(() => {
    let initial_mount = true;
    if (initial_mount) {
      let delivery = false;
      if (delivery) {
        setAppMode(2);
        setIsLoading(false);
      } else {
        setAppMode(1);
        setIsLoading(false);
      }
    }

    return () => {
      initial_mount = false;
    };

  }, []);
  return appMode == 1 ? <div> <DineInMain />  </div>: appMode == 2  ? <div> <DeliveryMain />  </div>: <div> <EnabillLoadingPage /> </div>;

}

export default Main;
